import { useContext } from 'react';
import { IRouterContext, RouterContext } from '../../router/Router';
import useMobileApp from '../../../../hooks/mobile-app/useMobileApp';

const useMobileRouter = (): IRouterContext => {
  const { isMobileApp } = useMobileApp();
  return (
    isMobileApp
      ? useContext(RouterContext)
      : {
          navigate: () => {},
          tab: undefined,
        }
  ) as IRouterContext;
};

export default useMobileRouter;
